"use client";

import { useRef } from "react";
import { ArrowRight } from "lucide-react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
gsap.registerPlugin(useGSAP, ScrollTrigger);
export default function Detailing() {
  const container = useRef<HTMLElement>(null);
  useGSAP(() => {
    const el = container.current;
    if (!el) return;
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.to(".society-bg", {
        yPercent: -8,
        ease: "none",
        scrollTrigger: {
          trigger: el,
          start: "top bottom",
          end: "bottom top",
          scrub: 1.2
        }
      });
      gsap.to(".society-arc", {
        rotate: 1.5,
        y: 6,
        duration: 12,
        ease: "sine.inOut",
        yoyo: true,
        repeat: -1,
        transformOrigin: "center center"
      });
      gsap.set(".society-eyebrow", {
        y: 24
      });
      gsap.to(".society-eyebrow", {
        opacity: 1,
        y: 0,
        duration: 0.9,
        ease: "power2.out",
        scrollTrigger: {
          trigger: el,
          start: "top 80%",
          once: true
        }
      });
      gsap.set(".society-word", {
        y: 40
      });
      gsap.to(".society-word", {
        opacity: 1,
        y: 0,
        duration: 1.1,
        ease: "power3.out",
        stagger: 0.08,
        scrollTrigger: {
          trigger: el,
          start: "top 80%",
          once: true
        }
      });
      gsap.set(".society-underline", {
        scaleX: 0,
        transformOrigin: "left center"
      });
      gsap.to(".society-underline", {
        scaleX: 1,
        duration: 0.7,
        ease: "power2.out",
        delay: 1.4,
        scrollTrigger: {
          trigger: el,
          start: "top 80%",
          once: true
        }
      });
      gsap.set(".society-body, .society-cta", {
        y: 24
      });
      gsap.to(".society-body, .society-cta", {
        opacity: 1,
        y: 0,
        duration: 0.9,
        ease: "power2.out",
        stagger: 0.12,
        delay: 0.4,
        scrollTrigger: {
          trigger: el,
          start: "top 80%",
          once: true
        }
      });
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set([".society-eyebrow", ".society-word", ".society-body", ".society-cta"], {
        opacity: 1,
        y: 0
      });
      gsap.set(".society-underline", {
        scaleX: 1,
        transformOrigin: "left center"
      });
    });
    const refresh = () => ScrollTrigger.refresh();
    requestAnimationFrame(refresh);
    if (document.readyState === "complete") refresh();else window.addEventListener("load", refresh, {
      once: true
    });
    document.fonts?.ready.then(refresh);
  }, {
    scope: container
  });
  const headlineLine1 = ["Premium", "mobile", "car"];
  const headlineLine2Before = ["detailing", "for", "your"];
  return;
}